import store from 'source/store';

// TODO (jaceroldan@bposeats.com)
// refactor this in the future to have permissions for scalema clients
function checkIfUserIsOrgExecOrScalemaClient(to, from, next) {
    const {
        is_organizational_exec,
        is_workforce_exec,
        applicant_id,
        user_type,
    } = store.state.auth.user.user_profile;

    const isApplicant = !!applicant_id && !!user_type;

    if (!is_organizational_exec && !is_workforce_exec && isApplicant)
        next({ name: 'page-not-found', replace: true });
    else next();
}


async function doesUserHaveAccessToTicketCard(userProfilePk, cardId) {
    const handlerCard = await store.dispatch('ticketBoard/queryTicketIssuer', cardId);

    const subscriberPks = handlerCard?.originator_channels?.flatMap(
        channel => channel.subscribers.map(user=>user.pk));

    if (
        userProfilePk !== handlerCard?.issuer?.pk &&
        !subscriberPks.includes(userProfilePk)
    ) {
        return false;
    }
    return true;
}

function redirectNewBusinessUser(to, from, next) {
    const isNewBusinessUser = JSON.parse(localStorage.getItem('is_new_business_user')) === true;

    if (isNewBusinessUser) {
        next({ name: 'overview-page', query: to.query, replace: true });
    } else {
        next();
    }
}

export default [
    {
        path: '/personal',
        name: 'personal-internal-root',
        component: () => import(
            'source/pages/root/InternalPageRoot.vue'),
        meta: {
            title: 'Personal Board Root',
            loginRequired: true,
            isInternal: true,
            isCompanyIndependent: true
        },
        children: [
            {
                path: 'personal-board',
                name: 'personal-board',
                component: () => import('source/pages/board/personal-board/PersonalBoard.vue'),
                meta: {
                    title: 'Personal - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }, {
                path: 'jobs-board',
                name: 'job-portal',
                component: () => import ('source/pages/applicants/JobPortalPage.vue'),
                props: true,
                meta: {
                    title: 'Job Portal - HQZen',
                    canDisplayGlobalModals: true
                },
            }, {
                path: 'contracts/:job_offer_id',
                name: 'sign-contracts',
                component: () =>
                    import ('source/pages/applicants/JobOfferSignContractsPage.vue'),
                props: true,
                meta: {
                    title: 'Sign Contracts - HQZen',
                    canDisplayGlobalModals: true
                },
            }, {
                path: 'request-tracker',
                name: 'ticket-board',
                component: () => import('source/pages/board/ticket-board/TicketBoard.vue'),
                beforeEnter: async (to, _from, next) => {
                    const userProfilePk = store.state.auth.user?.user_profile?.pk;
                    if (!userProfilePk) {
                        next({ name: 'signin' });
                        return;
                    }
                    // validate if user can view the card
                    // (card_id -> email, card -> ticket board)
                    const cardId = to.query?.card_id || to.query?.card;
                    if (cardId) {
                        const hasTicketCardAccess = await doesUserHaveAccessToTicketCard(userProfilePk, cardId);
                        if (!hasTicketCardAccess) {
                            next({ name: 'access-denied' });
                        }
                    }

                    const excludedQueries = ['card', 'card_id', 'comment_id'];
                    const validQueries = Object.freeze({
                        reopen: (value) => ['true', 'false'].includes(value),
                        rating: (value) => value <= 10 && value >= 1,
                        card: (value) => !!parseInt(value),
                    });
                    let filteredQuery = Object.keys(to.query).reduce((acc, key) => {
                        const isExcluded = excludedQueries.includes(key);
                        if (isExcluded || (validQueries[key] && validQueries[key](to.query[key]))) {
                            acc[key] = to.query[key];
                        }
                        return acc;
                    }, {});
                    /**Old email template*/
                    if ('feedback' in to.query && ['good', 'bad'].includes(to.query['feedback'])
                        && !('rating' in filteredQuery)) {
                        filteredQuery.rating = to.query['feedback'] === 'good' ? 10 : 1;
                    }

                    const queryChanged = JSON.stringify(to.query) !== JSON.stringify(filteredQuery);
                    if (queryChanged) {
                        next({ ...to, query: filteredQuery, replace: true });
                    } else {
                        next();
                    }
                },
                meta: {
                    title: 'Request Tracker - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }, {
                path: 'ticket-tracker',
                meta: {
                    canDisplayGlobalModals: true,
                },
                redirect: ({ query }) => ({
                    name: 'ticket-board',
                    query,
                })
            }, {
                path: 'ticket-board',
                meta: {
                    canDisplayGlobalModals: true,
                },
                redirect: ({ query }) => ({
                    name: 'ticket-board',
                    query,
                })
            }, {
                path: 'account-information',
                name: 'administrator-account-info',
                component: () =>
                    import(
                        'source/pages/employers/settings/SettingsSectionPage.vue'
                    ),
                beforeEnter: checkIfUserIsOrgExecOrScalemaClient,
                props: true,
                meta: {
                    title: 'Account Information - HQZen',
                    canDisplayGlobalModals: true,
                    isAdministratorRoute: true,
                },
            }, {
                path: 'exit-interview/details/:id',
                name: 'user-exit-interview-details',
                component: () => {
                    return import (
                        'source/pages/employers/staff/sub-sections/exit-interview/ExitInterviewDetailsPage.vue'
                    );
                },
                props: true,
                meta: {
                    title: 'Exit Interviews Details - HQZen',
                    canDisplayGlobalModals: true,
                },
            }, {
                path: 'account-information',
                name: 'client-account-info',
                component: () =>
                    import(
                        'source/pages/employers/settings/SettingsSectionPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Account Information - HQZen',
                    canDisplayGlobalModals: true,
                    isAdministratorRoute: true,
                },
            }, {
                path: 'contracts',
                name: 'employment-contracts',
                component: () => import('source/pages/employment/EmploymentsContractPage.vue'),
                props: true,
                meta: {
                    title: 'Contracts - HQZen',
                    canDisplayGlobalModals: true,
                },
                children: [
                    {
                        path: 'details/:contract_id',
                        name: 'employment-contract-details',
                        component: () => import('source/pages/employment/contracts/ContractDetailsPage.vue'),
                        props: true,
                        meta: {
                            title: 'Contracts - HQZen',
                            canDisplayGlobalModals: true,
                        }
                    }
                ]
            }
        ]
    },{
        path: '/home',
        name: 'home-internal-root',
        component: () => import(
            'source/pages/root/InternalPageRoot.vue'),
        meta: {
            title: 'Home Root',
            loginRequired: true,
            isInternal: true,
            isCompanyIndependent: true
        },
        children: [
            {
                path: 'home-page',
                name: 'home-page',
                component: () => import('source/pages/home/HomePage.vue'),
                beforeEnter: redirectNewBusinessUser,
                meta: {
                    title: 'Home - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }, {
                path: 'overview-page',
                name: 'overview-page',
                component: () => import('source/pages/home/OverviewsNewUserPage.vue'),
                meta: {
                    title: 'Overview - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }, {
                path: 'workforce-page',
                name: 'workforce-page',
                component: () => import('source/pages/home/WorkforcePage.vue'),
                meta: {
                    title: 'Workforce',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }, {
                path: 'exit-interview-page/:id',
                name: 'exit-interview-page',
                component: () => import('source/pages/home/ExitInterviewPage.vue'),
                meta: {
                    title: 'Exit Interview - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            },
        ]
    }
];
